export default "__VITE_ASSET__ca8881f7__"